export default {
  statScientistsTitle: "Tudósok és kutatók",
  statScientistsDescription: "Odaadó szakemberek, akik az innovációt hajtják a gyógyszeripari kutatásban és fejlesztésben",
  statScientistsImage: "https://readdy.ai/api/search-image?query=Professzion%C3%A1lis%20gy%C3%B3gyszeripari%20tud%C3%B3sok%20%C3%A9s%20kutat%C3%B3k%20dolgoznak%20modern%20laborat%C3%B3riumban&width=400&height=300",
  statProductsTitle: "Gyógyszeripari termékek",
  statProductsDescription: "Magas minőségű gyógyszeripari termékek és API-k átfogó portfóliója",
  statProductsImage: "https://readdy.ai/api/search-image?query=Magas%20min%C5%91s%C3%A9g%C5%B1%20gy%C3%B3gyszeripari%20term%C3%A9kek%20%C3%A1tfog%C3%B3%20portf%C3%B3li%C3%B3ja&width=400&height=300",
  statMarketsTitle: "Globális piacok",
  statMarketsDescription: "Egészségügyi szükségletek kiszolgálása különböző nemzetközi piacokon szabályozási kiválósággal",
  statMarketsImage: "https://readdy.ai/api/search-image?query=Glob%C3%A1lis%20gy%C3%B3gyszeripari%20piacok%20%C3%A9s%20nemzetk%C3%B6zi%20eg%C3%A9szs%C3%A9g%C3%BCgyi%20eloszt%C3%A1s&width=400&height=300",
};

